// © 2015-2021 WDNA - All Rights Reserved

import { RedirectProps, RouteProps } from 'react-router';

import Readings from './loaders/Readings';
import Sensors from './loaders/Sensors';
import Graphs from './loaders/Graphs';
import Waste from './loaders/Waste';
import Reports from './loaders/Reports';

export const redirects: RedirectProps[] = [
  {
    from: '/sensors',
    to: '/sensors/sensors',
  },
];

export const routes: RouteProps[] = [
  {
    component: Readings,
    path: '/sensors/readings',
  },
  {
    component: Sensors,
    path: '/sensors/sensors',
  },
  {
    component: Graphs,
    path: '/sensors/sensors_graphs',
  },
  {
    component: Waste,
    path: '/sensors/waste',
  },
  {
    component: Reports,
    path: '/sensors/reports',
  },
];
